import { getSentry } from './getSentry'
import './polyfills'
import './startup'
import { createRoot } from 'react-dom/client'
import { Suspense, lazy } from 'react'
import { retry } from './common/src/retry'
import { ReactQueryProvider } from './queries/react/configureReactQuery'

import('./startup-lazy.js')

// Error handling functionality moved from inline script in index.html
;(function () {
  var ready = false
  document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM fully loaded and parsed')
    ready = true
  })
  var handleError = function () {
    if (ready) {
      var slowInitError = document.getElementById('slowInit')
      if (slowInitError) {
        slowInitError.style.display = 'flex'
        var logoutLink = document.getElementById('logoutLink')
        if (logoutLink) {
          logoutLink.onclick = function () {
            try {
              localStorage.clear()
            } catch (err) {}
          }
        }
      }
    } else {
      var mainLoading = document.getElementById('mainLoading')
      if (mainLoading) {
        mainLoading.classList.remove('loadingContainer--hide')
      }

      var img = document.getElementById('mainLogo')
      if (img) {
        img.style.display = 'none'
      }

      var mainError = document.getElementById('mainError')
      if (mainError) {
        mainError.style.display = 'block'
      }

      var button = document.getElementById('mainReloadButton')
      if (button) {
        button.onclick = function () {
          window.location.reload()
        }
      }
    }
  }
  setTimeout(handleError, 15000) //15secs
})()

const App = lazy(() => retry(() => import('./App.jsx')))

const Sentry = getSentry()

const Core = () => (
  <ReactQueryProvider>
    <Suspense fallback={<></>}>
      <App />
    </Suspense>
  </ReactQueryProvider>
)

try {
  const container = document.getElementById('root')
  const root = createRoot(container)

  root.render(<Core />)
} catch (err) {
  Sentry.withScope(scope => {
    scope.setExtra('info', 'Unable to mount React node')
    Sentry.captureException(err)
  })
}
